import { Form, Input, Button, Spin, Typography, message } from 'antd';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';
import useHttpClient from '../../../shared/sendRequest/useHttpClient';
import EndPoints from '../../../shared/endPoints/EndPoints.json';
import { colors } from '../../../shared/styles/baseStyle';
import AuthLayout from '../../../components/AuthLayout/AuthLayout';
import AuthCard from '../../../components/AuthCard/AuthCard';
import {
  inputItem,
  buttonItem,
  button,
  cancelButtonRow,
  cancelButton
} from './styles';

const { Text } = Typography;

export default function RemindPolicyNumber() {
  const history = useHistory();
  const [form] = Form.useForm();
  const { sendRequest } = useHttpClient();

  const { mutate, isLoading } = useMutation(sendRequest, {
    onSuccess: () => {
      message.success(
        'Ο Αριθμός Συμβολαίου σου έχει αποσταλεί στο δηλωμένο e-mail.'
      );
      form.resetFields();
      history.push('/');
    }
  });

  const onFinish = data => {
    mutate({
      endpoint: `${EndPoints.CONTRACT.POLICYNUMBERBYPLATE}?Plate=${data.plateNumber}`,
      method: 'GET'
    });
  };

  return (
    <AuthLayout>
      <Spin spinning={isLoading} size="large">
        <AuthCard
          title="Υπενθύμιση Αριθμού Συμβολαίου"
          subtitle="Εισήγαγε τον Αρ. Κυκλοφορίας του οχήματός σου και θα λάβεις τον Αρ. Συμβολαίου σου στο email σου"
        >
          <Form form={form} onFinish={onFinish} layout="vertical">
            <Form.Item
              label={<Text strong>Αρ. Κυκλοφορίας (Πινακίδα Οχήματος)</Text>}
              name="plateNumber"
              rules={[
                {
                  required: true,
                  message: 'Παρακαλώ εισάγετε Αρ. Κυκλοφορίας'
                },
                {
                  pattern: /^[ΑΒΕΖΗΙΚΜΝΟΡΤΥΧ]{3}[0-9]{4}$/,
                  message:
                    'Ο Αρ. Κυκλοφορίας πρέπει να είναι της μορφής ΧΧΧ0000 με ελληνικά κεφαλαία'
                }
              ]}
            >
              <Input size="large" style={inputItem} allowClear maxLength={7} />
            </Form.Item>
            <Form.Item shouldUpdate style={buttonItem}>
              {() => {
                const hasErrors = form
                  .getFieldsError()
                  .some(({ errors }) => errors.length);
                const isDisabled =
                  !form.getFieldValue('plateNumber') || hasErrors;
                return (
                  <Button
                    htmlType="submit"
                    block
                    size="large"
                    disabled={isDisabled}
                    style={{
                      ...button,
                      background: isDisabled
                        ? colors.disabledGrey
                        : colors.anytimeBlue
                    }}
                  >
                    Αποστολή
                  </Button>
                );
              }}
            </Form.Item>
          </Form>
          <div style={cancelButtonRow}>
            <Button
              type="link"
              style={cancelButton}
              onClick={() => history.push('/')}
            >
              Άκυρο
            </Button>
          </div>
        </AuthCard>
      </Spin>
    </AuthLayout>
  );
}
